import axios, { throwIfServerError } from './apiServices/apiServices';

// #region PRE_ORDER_TIME
type GetRestaurantPreOrderTimesProps = {
  prId: string | number;
  deliveryType: number;
};
export const getRestaurantPreOrderTimes = async ({
  prId,
  deliveryType,
}: GetRestaurantPreOrderTimesProps) => {
  try {
    const result = await axios.get<{
      Data: { Label: string; Key: string; IsFull: boolean }[];
    }>(`/Restaurant/DeliverySlots/${prId}?deliveryType=${deliveryType}`);

    return result.data.Data.map((t) => ({
      Value: t.Label,
      Key: t.Key,
      IsFull: t.IsFull,
    }));
  } catch (error) {
    return throwIfServerError(error);
  }
};
// #endregion
